import actionTypes from "./actionTypes.js";
import namespace from './namespace';
export default {
  namespace,
  state: {
    detailConfig: {
      templateId: null
    },
    detailInfo: {},
    courseConfig: {},
    btnStatus: '',
    // 按钮状态
    lessonInfo: {
      lateLearnShow: false,
      // 是否有继续学习
      flag: false,
      // 数据是否已加载
      lesson: {},
      // 目录第一个课次
      lastlearn: {} // 上次学习的课次

    },
    allTypeTab: 'live' // 混合课tab

  },
  reducers: {
    [actionTypes.SERVICE_CONFIG_DETAIL](state, action) {
      return { ...state,
        detailConfig: { ...action.data
        }
      };
    },

    [actionTypes.SERVICE_CONFIG](state, action) {
      return { ...state,
        courseConfig: { ...action.data
        }
      };
    },

    [actionTypes.COURSE_DETAIL_INFO](state, action) {
      return { ...state,
        detailInfo: { ...action.data
        }
      };
    },

    [actionTypes.COURSE_BTN_STATUS](state, action) {
      return { ...state,
        btnStatus: action.data
      };
    },

    [actionTypes.COURSE_LESSON_INFO](state, action) {
      return { ...state,
        lessonInfo: { ...action.data
        }
      };
    },

    [actionTypes.COURSE_ALL_TAB](state, action) {
      return { ...state,
        allTypeTab: action.data
      };
    }

  }
};